const STATIC_BASE_PATH = '../../static',
  PRODUCT_IMAGE_BASE_PATH = STATIC_BASE_PATH + '/images/productImage';

export const mocLayoutData = [
  {}, {}, {
    index: 2,
    type: 'banner',
    title: '轮播图',
    componentContent: {
      bannerData: [
        // {
        //   name: 0,
        //   pic: 'static/images/bannerData/1-1.jpg',
        //   sort: 0,
        //   status: 1,
        //   url: '/'
        // }, {
        //   imgData: '',
        //   pic: 'static/images/bannerData/2-1.jpg',
        //   title: '',
        //   url: ''
        // }, {
        //   imgData: '',
        //   pic: 'static/images/bannerData/3-1.jpg',
        //   title: '',
        //   url: ''
        // }, {
        //   imgData: '',
        //   pic: 'static/images/bannerData/4-1.jpg',
        //   title: '',
        //   url: ''
        // }, {
        //   imgData: '',
        //   pic: 'static/images/bannerData/5-1.jpg',
        //   title: '',
        //   url: ''
        // }
        { pic: 'static/images/bannerData/analysis-1.jpg' },
        { pic: 'static/images/bannerData/elements.jpg' },
        { pic: 'static/images/bannerData/chemistry.jpg' },
        { pic: 'static/images/bannerData/chemistry3.jpg' },
      ]
    }
  }
];

export const mocHonorImgData = {
  route: '/',
  moreUrl: 'http://csyjs.bgrimm.com/zxgk/zzry/index.htm',
  imgData: [{
    pic: 'static/images/honorImgData/计量认证证书.png',
    label: '计量认证证书',
    route: '/',
    url: 'http://csyjs.bgrimm.com/zxgk/zzry/7139.htm'
  }, {
    pic: 'static/images/honorImgData/资质认定授权证书.png',
    label: '资质认定授权证书',
    route: '/',
    url: 'http://csyjs.bgrimm.com/zxgk/zzry/7140.htm'
  }, {
    pic: 'static/images/honorImgData/cnas-certificate.png',
    label: 'cnas certificate',
    route: '/',
    url: 'http://csyjs.bgrimm.com/zxgk/zzry/7138.htm'
  }, {
    pic: 'static/images/honorImgData/国家高新技术企业证书.png',
    label: '国家高新技术企业证书',
    route: '/',
    url: 'http://csyjs.bgrimm.com/zxgk/zzry/4136.htm'
  }, {
    pic: 'static/images/honorImgData/北矿检测技术有限公司计量认证证书CMA.png',
    label: '北矿检测技术有限公司计量认证证书CMA',
    route: '/',
    url: 'http://csyjs.bgrimm.com/zxgk/zzry/4135.htm'
  }, {
    pic: 'static/images/honorImgData/伦敦金属交易所（LME ）取样和化验机构证书.png',
    label: '伦敦金属交易所（LME ）取样和化验机构证书',
    route: '/',
    url: 'http://csyjs.bgrimm.com/zxgk/zzry/7150.htm'
  }]
};

export const mocTypesData = [
  {
    label: '金属与合金',
    value: 1,
    children: [
      {
        label: '铜及铜合金',
        pic: PRODUCT_IMAGE_BASE_PATH + '/CuTypesImage.jpg',
        value: 2
      }, {
        label: '铅及铅合金',
        pic: PRODUCT_IMAGE_BASE_PATH + '/PbTypesImage.jpg',
        value: 3
      }, {
        label: '锌及锌合金',
        pic: PRODUCT_IMAGE_BASE_PATH + '/ZnTypesImage.jpg',
        value: 4
      }, {
        label: '锡',
        pic: PRODUCT_IMAGE_BASE_PATH + '/SnTypesImage.jpg',
        value: 5
      }
    ]
  }, {
    label: '矿石与矿物',
    value: 6,
    children: [
      {
        label: '铜精矿',
        pic: PRODUCT_IMAGE_BASE_PATH + '/CuProductImage2.jpg',
        value: 7
      }, {
        label: '铅精矿',
        pic: PRODUCT_IMAGE_BASE_PATH + '/CuProductImage2.jpg',
        value: 8
      }
    ]
  }, {
    label: '环境',
    value: 9,
    children: [
      {
        label: '水',
        pic: PRODUCT_IMAGE_BASE_PATH + '/CuProductImage2.jpg',
        value: 10
      }, {
        label: '土壤',
        pic: PRODUCT_IMAGE_BASE_PATH + '/CuProductImage2.jpg',
        value: 11
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/mocData/indexAll.js